import React from 'react';
import cn from 'classnames';
import Action from '@components/Button/Action';
import styles from './Buttons.module.scss';

export function CSVModalButton({
  children,
  onClick,
  disabled,
  secondary,
  block,
  forceDarkMode,
}: {
  children: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  block?: boolean;
  secondary?: boolean;
  forceDarkMode?: boolean;
}) {
  return (
    <Action
      className={styles.button}
      onClick={onClick}
      disabled={disabled}
      secondary={secondary}
      block={block}
      forceDarkMode={forceDarkMode}
    >
      {children}
    </Action>
  );
}

export function CSVModalButtonRow({
  children,
  vertical,
}: {
  children: React.ReactNode;
  vertical?: boolean;
}) {
  return <div className={cn(styles.buttonRow, vertical && styles.vertical)}>{children}</div>;
}
